// Multivariate Dependencies
import { makeStyles } from '@material-ui/core/styles';
/**
 * @deprecated Do not use legacy components anymore.
 */
export var useAvatarStyles = makeStyles(function (theme) { return ({
    avatar: {
        backgroundColor: theme.palette.primary.main,
        width: function (_a) {
            var size = _a.size;
            return size;
        },
        height: function (_a) {
            var size = _a.size;
            return size;
        },
        fontSize: function (_a) {
            var size = _a.size;
            return size * 0.4;
        },
        fontWeight: 'bold',
        color: function (_a) {
            var color = _a.color;
            return color || '#fff';
        },
    },
}); });
//# sourceMappingURL=useAvatarStyles.js.map